<template>
  <IconLucideImages />
</template>s
